import debounce from 'lodash.debounce';
import { useState } from 'react';

import Provision from '../api/provision';

import useApiQuery from './useApiQuery';

interface JuiceGroupData {
  title?: string;
}

const useJuiceGroupValidation = () => {
  const [isCheckingJuiceGroup, setIsCheckingJuiceGroup] = useState(false);
  const [juiceGroupError, setJuiceGroupError] = useState('');

  const { makeApiCall: getJuiceGroupCall } = useApiQuery<JuiceGroupData>(
    Provision.fetchJuiceGroupByName
  );

  const handleCheckJuiceGroup = async (value: string): Promise<void> => {
    if (!value) return;

    setIsCheckingJuiceGroup(true);
    const data: JuiceGroupData | null = await getJuiceGroupCall(value);

    const juiceGroupAvailability = data?.title;

    setJuiceGroupError(
      juiceGroupAvailability === 'Not Found' ? '' : 'Juice Group invalid or already exists'
    );

    setIsCheckingJuiceGroup(false);
  };

  const checkJuiceGroup = debounce(handleCheckJuiceGroup, 800);

  return {
    juiceGroupError,
    isCheckingJuiceGroup,
    checkJuiceGroup,
  };
};

export default useJuiceGroupValidation;
